import React from "react";

const BreadcrumbIcon = ({ settings, isMobile, icon }) => {
    const { section } = settings;
    const dividerType = section.divider_type || "icon";
    const dividerText = section.divider_text || "/";
    const spacing = isMobile ? section.spacing_mobile : section.spacing;
    
    const dividerStyle = {
        paddingLeft: `${spacing}px`,
        paddingRight: `${spacing}px`,
    };

    if (dividerType === "text") {
        return (
            <span 
                className="breadcrumb-divider" 
                style={dividerStyle}
            >
                {dividerText}
            </span>
        );
    }
    
    return (
        <i
            className={`icon ${icon ?? section.icon} breadcrumb-icon`}
            style={{
                ...dividerStyle,
                fontSize: `${section.icon_size}px`,
            }}
        />
    );
};

export default BreadcrumbIcon;
